
import React from 'react';

interface Match {
  Date: string;
  HomeTeam: string;
  AwayTeam: string;
  FTHG: string;
  FTAG: string;
  FTR: string;
  HTHG: string;
  HTAG: string;
  HC: string;
  AC: string;
  Referee: string;
  HS: string;
  AS: string;
  HST: string;
  AST: string;
  HF: string;
  AF: string;
  HY: string;
  AY: string;
  HR: string;
  AR: string;
  oddsData?: Record<string, string>;
}

interface MatchDetailsListProps {
  matches: Match[];
  selectedStat: string | null;
  showOdds?: boolean;
}

export const MatchDetailsList: React.FC<MatchDetailsListProps> = ({ 
  matches, 
  selectedStat,
  showOdds = false 
}) => {
  return (
    <div className="space-y-4">
      {matches.map((match) => {        
        return (
          <div 
            key={`${match.Date}-${match.HomeTeam}-${match.AwayTeam}`} 
            className="border rounded-lg p-4 bg-white shadow-sm"
          >
            <div className="flex justify-between items-center mb-4">
              <span className="text-sm text-gray-600">
                {match.Date}
              </span>
              <span className="text-sm font-medium">
                {match.HomeTeam} vs {match.AwayTeam}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-8">
              <div>
                <h4 className="text-sm font-semibold mb-2">Match Stats</h4>
                <div className="space-y-1 text-sm">
                  <p>Full Time: {match.FTHG} - {match.FTAG}</p>
                  <p>Half Time: {match.HTHG} - {match.HTAG}</p>
                  <p>Corners: {match.HC} - {match.AC}</p>
                  {match.Referee && (
                    <p>Referee: {match.Referee}</p>
                  )}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold mb-2">Additional Info</h4>
                <div className="space-y-1 text-sm">
                  <p>Shots: {match.HS} - {match.AS}</p>
                  <p>Shots on Target: {match.HST} - {match.AST}</p>
                  <p>Fouls: {match.HF} - {match.AF}</p>
                  <p>Cards: 🟨 {match.HY}-{match.AY} 🟥 {match.HR}-{match.AR}</p>
                </div>
              </div>
            </div>
            
            {showOdds && match.oddsData && Object.keys(match.oddsData).length > 0 && (
              <div className="mt-3 pt-3 border-t">
                <h4 className="text-sm font-semibold mb-2">Betting Odds</h4>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <h5 className="text-xs font-medium mb-1">Home</h5>
                    <div className="space-y-1 text-xs">
                      {Object.entries(match.oddsData)
                        .filter(([key]) => key.endsWith('H'))
                        .map(([key, value]) => (
                          <p key={key}>{value}</p>
                        ))}
                    </div>
                  </div>
                  <div>
                    <h5 className="text-xs font-medium mb-1">Draw</h5>
                    <div className="space-y-1 text-xs">
                      {Object.entries(match.oddsData)
                        .filter(([key]) => key.endsWith('D'))
                        .map(([key, value]) => (
                          <p key={key}>{value}</p>
                        ))}
                    </div>
                  </div>
                  <div>
                    <h5 className="text-xs font-medium mb-1">Away</h5>
                    <div className="space-y-1 text-xs">
                      {Object.entries(match.oddsData)
                        .filter(([key]) => key.endsWith('A'))
                        .map(([key, value]) => (
                          <p key={key}>{value}</p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
